<!-- <h2 mat-dialog-title class="fw-bold mb-4">No. of Tobacco Bales</h2>
<mat-dialog-content class="mat-typography buying-bales-counter-section">
    <div>
        <div class="card-header">
            <h2 class="card-title mb-4">No. of Tobacco Bales</h2>
        </div>
        <div class="card-body">
            <div class="align-items-center gap-3 mb-4 d-flex flex-row justify-content-center">
                <div class="custom-input-wrap bales-counter">
                    <mat-form-field class="custom-input" appearance="outline">
                        <input matInput type="number" [(ngModel)]="valueCounter" />
                    </mat-form-field>
                </div>

                <div class="d-flex flex-column gap-3">
                    <button class="increment-counter-btn align-items-center d-flex justify-content-center"
                        mat-button mat-icon-button aria-label="Add" disableRipple
                        (click)="incrementValue()">
                        <mat-icon disableRipple>add</mat-icon>
                    </button>
                    <button class="decrement-counter-btn align-items-center d-flex justify-content-center"
                        mat-button mat-icon-button aria-label="Remove" [disabled]="disableDecrementBtn"
                        (click)="decrementValue()">
                        <mat-icon>remove</mat-icon>
                    </button>

                </div>

            </div>
        </div>
    </div>

</mat-dialog-content>

<mat-dialog-actions align="center" class="action-buttons-wrapper align-content-center align-items-center d-flex gap-4 justify-content-center mt-auto mb-auto">
    <button mat-stroked-button mat-dialog-close class="g-btn g-tertiary-btn">Cancel</button>
    <button mat-flat-button class="g-btn g-primary-btn">OK</button>
</mat-dialog-actions> -->

<!-- <div class="g-small-model align-items-center d-flex flex-column gap-1 justify-content-center">
<h1 mat-dialog-title class="success-dialog-heading text-center mb-2">Success!</h1>
<mat-dialog-content class="text-center">
    <div class="success-dialog-content">The Data is updated</div>
</mat-dialog-content>
<mat-dialog-actions  align="center" class="action-buttons-wrapper align-content-center align-items-center d-flex gap-4 justify-content-center">
    <button mat-stroked-buttonc class="g-btn g-tertiary-btn">Go to home</button>
    <button mat-flat-button class="g-btn g-primary-btn">Update Again</button>
</mat-dialog-actions>
</div> -->


<div class="spanner-loader" *ngIf="apiCall">
  <mat-spinner></mat-spinner>
  </div>

<div class="g-small-model align-items-center d-flex flex-column gap-1 justify-content-center">
  <h3 mat-dialog-title class="success-dialog-heading text-center mb-2">Confirmation!</h3>
  <mat-dialog-content class="text-center">
      <div class="success-dialog-content fs-6">Are you sure you want to proceed?</div>
  </mat-dialog-content>
  <mat-dialog-actions  align="center" class="action-buttons-wrapper align-content-center align-items-center d-flex gap-4 justify-content-center">
      <button mat-stroked-button  class="g-btn g-tertiary-btn" (click)="ok()">Yes
        <!-- <mat-spinner  [diameter]="15"
        [strokeWidth]="1" *ngIf="apiCall" ></mat-spinner> -->
      </button>
      <button mat-flat-button mat-dialog-close  class="g-btn v g-primary-btn">No</button>

      <button mat-stroked-button mat-dialog-close id="closeHome" class="d-none">Go to home</button>
  </mat-dialog-actions>
  </div>
